import React from 'react';
import './index.css';
import App from './App';
import * as ReactDOMClient from 'react-dom/client';
import "@nike/eds/dist/index.css";
import {BrowserRouter} from "react-router-dom";
import store from './shared/store/Store';
import { Provider } from 'react-redux';

let productWeightsOverviewContainer = null;
let root = null;

window.renderProductWeightsOverview = (containerId) => {
    if (!productWeightsOverviewContainer) {
        productWeightsOverviewContainer = document.getElementById(containerId);
        root = ReactDOMClient.createRoot(productWeightsOverviewContainer);
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <Provider store={store}>
                        <App />
                    </Provider>
                </BrowserRouter>
            </React.StrictMode>
        );
    }
}

window.unmountProductWeightsOverview = containerId => {
    root.unmount();
    productWeightsOverviewContainer = null;
    root = null;
}